import { useMutation } from "react-query";
import { useGetCurrentAcademicYearQuery } from "../../hooks/useGetCurrentAcademicYearQuery";
import { createTeacherEvaluationCriteria } from "../../services/school/teacher/teacherEvaluationCriteria";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { TeacherEvaluationCriteriaType } from "../../types/TeacherEvaluation";
import toast from "react-hot-toast";
import { routes } from "../../routes";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { Card, Flex, Button, Spinner } from "@radix-ui/themes";
import TextFieldComponent from "../../components/inputs/Textfield/TextfieldComponent";
import RadioGroupComponent from "../../components/inputs/RadioGroup/RadioGroupComponent";
import { TeacherEvaluationFormValidation } from "./TeacherEvaluationFormValidation";
import { yupResolver } from "@hookform/resolvers/yup";

export const CreateTeacherEvaluationCriterias = () => {
  const mutation = useMutation({ mutationFn: createTeacherEvaluationCriteria, mutationKey: 'createTeacherEvaluationCriteria' });
  const { data: currentAcademicYear, isLoading: isLoadingCurrentAcademicYear, isError: errorCurrentAcademicYear } = useGetCurrentAcademicYearQuery();
  const navigate = useNavigate();
  const defaultValues: TeacherEvaluationCriteriaType= {
    idAcademicYear: currentAcademicYear?.id!,
    description: "",
    isForStudent: true,
    status: true
  }
  if(currentAcademicYear?.id){
    defaultValues.idAcademicYear = currentAcademicYear?.id;
  }
  const { control, handleSubmit, formState: { errors }, getValues,setValue } = useForm<TeacherEvaluationCriteriaType>
  (
    {
     resolver: yupResolver(TeacherEvaluationFormValidation),
      defaultValues: defaultValues,
      mode: 'onBlur',
      reValidateMode: 'onBlur',
      shouldUseNativeValidation: false,
    }
  );
  const onSubmit = handleSubmit(async (data) => {
    try {
      data.idAcademicYear = currentAcademicYear?.id!;
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Critério de avaliação criado!");
        navigate(routes.teacherEvaluationCriterias);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });
  const handleBack = () => {
    navigate(routes.teacherEvaluationCriterias);
  }
  return (
    <form onSubmit={onSubmit} noValidate>
    <Card size='1'>
      <Flex direction='column' gap='4'>
        <TextFieldComponent name="description" label="Descrição" control={control} errors={errors} fieldProps={{ placeholder: 'Descrição' }} required={true}/>
          <RadioGroupComponent name="isForStudent" label="Para estudantes?" control={control} errors={errors} style={{ width: '100%' }}
            options={[
              { value: "true", label: "Sim" }
              , { value: "false", label: "Não" }]}
            fieldProps={{
              style: { display: 'flex', flexDirection: 'row', gap: '16px' }
            }}
          />
        <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
          <Button color='red' onClick={handleBack} disabled={mutation.isLoading}>
            <ChevronLeftIcon /> voltar
          </Button>
          <Button type="submit" disabled={mutation.isLoading} variant='surface'  >
            {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
            Registar
          </Button>
        </Flex>

      </Flex>
    </Card>
    
  </form>
  )
}
